import { Card as PrimitiveCard, Typography } from "@packages/ds";
import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const Layout = styled.div`
  display: flex;
  gap: 32px;
  flex: 1;
  width: 100%;
  flex-direction: column;

  @media (min-width: ${breakpoints[2]}) {
    flex-direction: row;
  }
`;

export const Card = styled(PrimitiveCard)<{ $alignTop?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  ${({ $alignTop }) =>
    $alignTop ? "padding-top: 150px;" : "justify-content: center;"}
`;

export const Title = styled(Typography.BodyText).attrs(() => ({
  weight: "bold"
}))`
  margin-top: 26px;
  margin-bottom: 32px;
`;
